module.exports = __webpack_public_path__ + "img/case5.653c9bdd.png";